// import { useState } from "react";
// import { getLoggedinUser, getUserRole } from "../helpers/api_helper";

// const useProfile = () => {
//   const userProfileSession = localStorage.getItem("access");

//   const userRole = localStorage.getItem("role");

//   const [loading] = useState(userProfileSession ? false : true);
//   const [userProfile] = useState(
//     userProfileSession ? userProfileSession : null
//   );
//   const [role] = useState(userRole ? userRole : null);

//   return { userProfile, loading, role };
// };

// export { useProfile };


import { useEffect, useState } from "react";

const useProfile = () => {
  const [userProfile, setUserProfile] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    if (typeof window !== "undefined") {
      const accessToken = localStorage.getItem("access");
      const userRole = localStorage.getItem("role");

      setUserProfile(accessToken || null);
      setRole(userRole || null);
      setLoading(false); 
    }
  }, []);

  return { userProfile, loading, role };
};

export { useProfile };
